export function isFunction(name: string): boolean {
  return ['sqrt', 'sin', 'cos', 'acos', 'asin', 'tan', 'atan', 'random', 'log', 'round'].includes(
    name,
  );
}
